<template>
    <rkm-area
        no-margin-top
        title="Fichas de notificações de casos suspeitos"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.finalizacao.casosSuspeitos"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.nome"
                                    label="Nome"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>